import React from "react";
import "./ColorChart.scss";
import Rodal from "rodal";
import { useDispatch, useSelector } from "react-redux";
import { toggleColorChart } from "../../Redux/Toggles/Toggles.actions";
import img from "../../Assets/colorchart.jpg";

const ColorChart = (props) => {
  const show = useSelector((state) => state.toggles.colorChart);
  const dispatch = useDispatch();

  const getHeightWidth = () => {
    const mq = window.matchMedia("screen and (max-width: 800px)").matches;
    if (mq) {
      return {
        height: 70,
        width: 95,
      };
    }

    return {
      height: 75,
      width: 60,
    };
  };

  return (
    <Rodal
      onClose={() => dispatch(toggleColorChart(false))}
      visible={show}
      height={getHeightWidth().height}
      width={getHeightWidth().width}
      measure="%"
      className="ColorChart"
    >
      <img src={img} alt="kajsdh" className="img" />
    </Rodal>
  );
};

export default ColorChart;
